<ng-container *ngIf="state.state$ | async as draft">
    <header class="step-header">
        <h2>Build your organization structure</h2>
        <p class="lede">
            Drag, rename, and reparent positions just like in the post-create org board.
            Nothing is written to the backend until you submit on the final step.
        </p>
        <p class="muted limits">
            Limits: max <strong>{{ maxParts }}</strong> positions, max depth <strong>{{ maxDepth }}</strong>.
            Currently using <strong>{{ draft.structure.length }}</strong>.
        </p>
    </header>

    <!-- CEO post selector (crown 👑) is rendered inline on each post row by
         the shared OrgPartTreeBuilder via the `isPostCrowned` /
         `onTogglePostCrown` hooks supplied through BuilderConfig. -->
    <p class="ceo-hint" [class.is-error]="!ceoPostKey">
        <span class="ceo-hint-glyph" aria-hidden="true">👑</span>
        <ng-container *ngIf="ceoPostKey; else needCeo">
            CEO post:
            <strong>{{ ceoPostName }}</strong>
            <span class="muted">— click the crown 👑 on any post row to move it.</span>
        </ng-container>
        <ng-template #needCeo>
            <strong>Pick a CEO post</strong> — click the crown 👑 on the post that should hold the org creator's CEO hat.
        </ng-template>
    </p>

    <section class="builder-host" *ngIf="config; else noDraft">
        <lib-org-part-tree-builder
            [config]="config"
            [initialTree]="initialTree"
            [partTypes]="partTypes"
            [isDeveloper]="false"
        ></lib-org-part-tree-builder>
    </section>

    <ng-template #noDraft>
        <p class="muted">Loading…</p>
    </ng-template>
</ng-container>
